import { Button } from "@ab-inbev-maz/compass";
import NavigationHeader from "@/components/navigation/NavigationHeader";
import Loading from "@/features/sso-auth/components/Loading";
import { FormFieldsStep } from "@/components/commos/FormStep";
import { DetailView } from "@/components/commos/DetailView";
import { useDetailLegals } from "@/hooks/legals/useDetailLegals";
import { createLegalSchema } from "@/schemas/legal/legal";

const DetailLegals = () => {
    const { 
        valueDetails,
        isFetching,
        onSubmit,
        fields,
        isEditing,
        isLoading,
        formRef,
        values, 
        setIsEditing
    } = useDetailLegals();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
                <div className="max-w-sm w-full space-y-8 bg-white p-8 rounded-3xl shadow-lg">
                <Loading message="Esto solo va tomar un momento, estamos cargando el legal." />
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            <NavigationHeader
                title={`Legal: ${values.name || ''}`}
                description="Aquí podras revisar toda la información de tu legal"
                actions={[
                    <Button
                        key="edit-save"
                        label={isEditing ? "Guardar" : "Editar"}
                        variant="primary"
                        rightIcon={isEditing ? "functionalities/save" : "functionalities/edit-2"}
                        onClick={isEditing ? () => formRef.current?.submit() : setIsEditing?.bind(null, true)}
                        disabled={isFetching}
                    />,
                ]}
            />

            <hr className="border-gray-200 container mx-auto mt-2" />

            <div className="container mx-auto px-4 py-8">
                <p className="mb-3 text-sm font-medium text-gray-700">Información del legal</p>
                <div>
                    {
                    isEditing
                        ? (
                            <div>
                                <div className="p-6 rounded-xl border border-gray-200 bg-white">
                                    <FormFieldsStep
                                        ref={formRef}
                                        schema={createLegalSchema}
                                        defaultValues={values}
                                        fields={fields as any}
                                        onComplete={onSubmit}
                                        isFetching={isFetching}
                                        formId="sku-general-info"
                                        description=""
                                        editMode={true}
                                    />
                                </div>
                            </div>
                        ) : (
                            <DetailView
                                data={valueDetails}
                            />
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default DetailLegals;